import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Redirect } from "react-router";
import { URLS } from "../../_config";
import Layout from "../layout/Layout";
import { useAuthStatus } from "../hooks/auth/authHook";
import { useAppUserDetailsSelector } from "../hooks/selectors/userSelector";
import { useAppEventAction } from "src/_common/hooks/actions/event/appEventActionHook";
import { useUserApi } from "../hooks/actions/user/appUserApiHook";
import { useSelector } from "react-redux";
import { StateExtended } from "../interfaces/StateExtended";

const requireAuth = (Component: React.ComponentType, role: number = 0) => {
  function AuthHoc(props: any) {
    const isAuth = useAuthStatus();
    const user = useAppUserDetailsSelector();
    const location = useLocation();
    const permissions = useSelector((state: StateExtended) => state.user.permissions);
    const userApi = useUserApi();
    
    //Save value to Redux
    const eventAction = useAppEventAction();
    
    useEffect(() => {
      eventAction.updateReferrerUrl(location.pathname);
    }, [location]);

    // Auto-refresh permissions for member users if not loaded
    useEffect(() => {
      if (isAuth && user && user.user_type === 'member' && user?.user?.id) {
        console.log('Loading permissions for member user on page refresh...');
        userApi.callGetUserPermissions(
          user?.user?.id,
          (message: string, response: any) => {
            console.log('Permissions loaded successfully on page refresh');
          },
          (error: any) => {
            console.warn('Failed to load permissions on page refresh:', error);
          }
        );
      }
    }, [isAuth, user]);

    /**
     * TODO: add role bases checking here
     */
    return (
      // isAuth && user && user.user_type === role ? <Layout>
      isAuth && user ? (
        <Layout>
          <Component {...props} />
        </Layout>
      ) : (
        <Redirect to={URLS.AUTH.LOGIN} />
      )
    );
  }

  return AuthHoc;
};
export default requireAuth;
